import React, { useState, useEffect } from 'react';
import axios from 'axios';

import { Container, Row, Col, Button } from 'reactstrap';

import Add from '../icons/add.svg';
import Edit from '../icons/edit.svg';
import View from '../icons/view.svg';
import Delete from '../icons/delete.svg';

import { InputTextarea } from 'primereact/inputtextarea';
import { DataTable } from 'primereact/datatable';
import { InputText } from 'primereact/inputtext';
import { Paginator } from 'primereact/paginator';
import { Dropdown } from 'primereact/dropdown';
import { classNames } from 'primereact/utils';
import { Column } from 'primereact/column';
import { Dialog } from 'primereact/dialog';

import { Form, Field } from 'react-final-form';

import { LOOKUP_TYPES_LIST, EDIT_LOOKUP_TYPES, ADD_LOOKUP_TYPES } from '../../config/config.js';

let initialValue = {
  lookupName: '', description: '',
  lookupType: '', 
};

const LookupTypes = () => {
  const [tableData, setTableData] = useState([]);
  const [load, setLoad] = useState(false);
  const [newId, setNewId] = useState('');
  const [openPopup, setOpenPopup] = useState(false);
  const [popup, setPopup] = useState(false);
  const [view, setView] = useState(false);
  const [viewHead, setVHead] = useState('');
  const [filter, setFilter] = useState('');

  const [totalRecord, setTRecords] = useState(0);
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(10);
  const [page, setPage] = useState(0);

  let mainId = JSON.parse(sessionStorage.getItem('id')) ? JSON.parse(sessionStorage.getItem('id')) : 1; 

  const loadData = (page, filter, row) => {
    setLoad(true);

    axios({
      method: 'get',
      url: LOOKUP_TYPES_LIST+'&limit='+row+'&skip='+(page+1)+(filter!=='' && '&search='+filter),
    }).then((res) => {
      if (res.data) {
        setTableData(res.data.rows); setLoad(false); 
        setTRecords(res.data.total_count);
      } else {
        setLoad(false); setTRecords(0);
      }
    }).catch((err) => {
      console.log(err);
    });
  };

  const handleView = (e) => {
    setView(true); setVHead(e.LOOKUP_TYPE_DISPLAY_NAME);
    
    initialValue = {
      description: e.DESCRIPTION,
      lookupName: e.LOOKUP_TYPE_DISPLAY_NAME,
      lookupType: e.LOOKUP_TYPE,
    };
  };

  const handleEdit = (e) => {
    setPopup(true); setVHead(e.LOOKUP_TYPE_DISPLAY_NAME); setNewId(e.ID);

    initialValue = {
      description: e.DESCRIPTION,
      lookupName: e.LOOKUP_TYPE_DISPLAY_NAME,
      lookupType: e.LOOKUP_TYPE,
    };
  };
  
  const handleClickOpen = (event) => {
    setNewId(event.ID); setVHead(event.LOOKUP_TYPE);
    setOpenPopup(true);
  };

  const handleCloseDelete = () => {
    setOpenPopup(false); 
    setVHead(''); setNewId('');
  };

  const handleDelete = () => {
    axios({
      method: 'delete',
      url: EDIT_LOOKUP_TYPES + newId,
    }).then((res) => {
      console.log(res); setOpenPopup(false);
      loadData(page, filter, rows);
    });
  };

  const addLookupType = (obj, form) => {
    axios({
      method: 'post',
      url: ADD_LOOKUP_TYPES,
      data: obj
    }).then((res) => {
      setVHead(''); form.restart();
      setPopup(false); loadData(page, filter, rows);
    }).catch((err) => {
      console.log(err);
    });
  };

  const editLookType = (obj, form) => {
    axios({
      method: 'put',
      url: EDIT_LOOKUP_TYPES + newId,
      data: obj
    }).then((res) => {
      setVHead(''); setNewId(''); loadData(page); 
      form.restart(); setPopup(false);
    }).catch((err) => {
      console.log(err);
    });
  };

  const handleOnSubmit = (data, form) => {
    let obj = {
      'LOOKUP_TYPE': data.lookupType,
      'LOOKUP_TYPE_DISPLAY_NAME': data.lookupName,
      'DESCRIPTION': data.description,
      'UPDATED_BY': mainId,
    };

    if(newId===''){
      obj.CREATED_BY = mainId;
      
      addLookupType(obj, form);
    }else{
      editLookType(obj, form);
    };
  };

  useEffect(() => {
    loadData(page, filter, rows);
  }, [filter]);
    
  const tableHeader = () => {
    return <div className='DataTable'>
      <div className='m-2'>
        <h3>Lookup Type List</h3></div>

      <div className='table-header-action'>
        <InputText className='m-2' value={filter} onChange={(e)=>setFilter(e.target.value)} placeholder='Search...' />
        <Button variant="contained" className='table-button m-2' onClick={() => setPopup(true)}><img src={Add} style={{ width: '25px', height: '20px', marginRight:0.5}}/>Add</Button>
      </div>
    </div>
  };

  const actionHeader=(rowData)=>{
    return <div style={{display: 'flex', flexDirection: 'row'}}>
        <img
          src={View}
          alt='View Image'
          onClick={() => handleView(rowData)} 
          style={{marginRight: '25%', width: '25px', height: '20px'}}
        />

        <img
          src={Edit}
          alt='Edit Image'
          onClick={() => handleEdit(rowData)}
          style={{marginRight: '25%', width: '25px', height: '20px'}}
        />
     
        <img
          src={Delete}
          alt='Delete Image'
          style={{width: '25px', height: '20px'}}
          onClick={() => handleClickOpen(rowData)}
        />
    </div> 
  };

  const handleClose = () => {
    setPopup(false);
    setVHead(''); setView(false)
  };

  const validate = (data) => {
    let errors = {};

    if (!data.lookupName) {
      errors.lookupName = 'Lookup Name is required.';
    }

    if (!data.lookupType) {
      errors.lookupType = 'Lookup Type is required.';
    }

    if (!data.description) {
      errors.description = 'Description is required.';
    }

    return errors;
  };

  const isFormFieldValid = (meta) => !!(meta.touched && meta.error);

  const getFormErrorMessage = (meta) => {
    return isFormFieldValid(meta) && <small className="p-error">{meta.error}</small>;
  };

  const pageTemplate = {
    layout: 'RowsPerPageDropdown FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport',
    'RowsPerPageDropdown': (options) => {
      const dropdownOptions = [
        { label: 10, value: 10 },
        { label: 25, value: 25 },
        { label: 50, value: 50 },
        { label: 100, value: 100 },
      ];

      return (
        <React.Fragment>
          <Dropdown value={options.value} options={dropdownOptions} onChange={options.onChange} />
        </React.Fragment>
      );
    },
    'CurrentPageReport': (options) => {
      return (
        <span style={{ color: 'var(--text-color)', userSelect: 'none', width: '150px', textAlign: 'center' }}>
          {options.first} - {options.last} of {options.totalRecords}
        </span>
      )
    }
  };

  const onPage = (e) => {
    setFirst(e.first); setPage(e.page); 
    setRows(e.rows); loadData(e.page, filter, e.rows);
  };

  return (
    <div className='pt-4 m-3'>  
      <div style={{ width: "100%" }} className='datatable'>
        <DataTable 
          value={tableData} header={tableHeader} loading={load}
          removableSort globalFilter={filter} scrollable scrollHeight="64vh"
        >
          <Column header='Lookup Type' field='LOOKUP_TYPE' className=' text-truncate' sortable />
          <Column header='Lookup Name' field='LOOKUP_TYPE_DISPLAY_NAME' className=' text-truncate' sortable />
          <Column header='Description' field='DESCRIPTION' className=' text-truncate' sortable />
          <Column header='Actions' body={actionHeader} />
        </DataTable>

        <Paginator rows={rows} first={first} totalRecords={totalRecord} onPageChange={onPage} template={pageTemplate} />
      </div>  

      {/* Delete Pop-up */}
      <Dialog
        visible={openPopup} onHide={handleCloseDelete}
        header={<h5>You want to delete the record ?</h5>}
        className='text-center'
      >
        <Button onClick={handleCloseDelete} style={{marginRight: '5%'}}>No</Button>
        <Button onClick={handleDelete}>Yes</Button>
      </Dialog>  

      {/* Add / Edit Pop-up */}
      <Dialog
        visible={popup} onHide={handleClose}
        style={{width: '65vw', height: '60vh'}}
        header={<h5 style={{textAlign: 'center'}}>{viewHead==='' ? 'Add Lookup Type' : `Edit Lookup Type - ${viewHead}`}</h5>}
      >
        <Container className='p-2'>
          <Form
            onSubmit={handleOnSubmit} 
            initialValues={initialValue}
            validate={validate}
            render={({ handleSubmit }) => (
              <form onSubmit={handleSubmit}>
                <Row>
                  <Col xs={12} sm={6}>
                    <Field name='lookupType' render={({ input, meta }) => (
                      <>
                        <label className={classNames({ 'p-error': isFormFieldValid(meta) })}>Lookup Type *</label>
                        <InputText {...input} className={classNames({ 'p-invalid': isFormFieldValid(meta) })} style={{width: '100%'}} />
                        {getFormErrorMessage(meta)}
                      </>
                    )} />
                  </Col>

                  <Col xs={12} sm={6}>
                    <Field name='lookupName' render={({ input, meta }) => (
                      <>
                        <label className={classNames({ 'p-error': isFormFieldValid(meta) })}>Display Name *</label>
                        <InputText {...input} className={classNames({ 'p-invalid': isFormFieldValid(meta) })} style={{width: '100%'}} />
                        {getFormErrorMessage(meta)}
                      </>
                    )} />
                  </Col>

                  <Col xs={12} sm={12}>
                    <Field name='description' render={({ input, meta }) => (
                      <>
                        <label className={classNames({ 'p-error': isFormFieldValid(meta) })}>Description *</label>
                        <InputTextarea {...input} className={classNames({ 'p-invalid': isFormFieldValid(meta) })} style={{width: '100%'}} rows={5} cols={30} autoResize />
                        {getFormErrorMessage(meta)}
                      </>
                    )} />
                  </Col>

                  <Col xs={12} className='status_button text-center'>
                    <Button className='contained_primary' onClick={handleSubmit}>Submit</Button>
                  </Col>
                </Row>
              </form>
            )} 
          />
        </Container>
      </Dialog>

      {/* View Pop-up */}
      <Dialog
        visible={view} onHide={handleClose}
        // style={{width: '45vw', height: '45vh'}}
        header={<div><h5>{`View Details - ${viewHead}`}</h5></div>}
      >
        <Container>
          <Row>
            <Col xs={4} className='sub_heading_1'>Lookup Type</Col>
            <Col xs={1}>:</Col>
            <Col xs={6}>{initialValue.lookupType}</Col>
         
            <Col xs={4} className='sub_heading_1'>Lookup Name</Col>
            <Col xs={1}>:</Col>
            <Col xs={6}>{initialValue.lookupName}</Col>
          
            <Col xs={4} className='sub_heading_1'>Description</Col>
            <Col xs={1}>:</Col>
            <Col xs={6}>{initialValue.description}</Col>
          </Row>
        </Container>
      </Dialog>
    </div>
  );
};

export default LookupTypes;